import React, { useState } from 'react';

export interface TabDef {
  id: string;
  heading?: React.ReactNode;
  label?: string;
  content: React.ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  tabs: TabDef[];
  defaultTab?: string;
  activeTab?: string;
  onTabChange?: (id: string) => void;
}

export function Tabs({ tabs, defaultTab, activeTab, onTabChange }: TabsProps) {
  const [internalId, setInternalId] = useState(defaultTab ?? tabs.find(t => !t.disabled)?.id ?? tabs[0]?.id);
  const activeId = activeTab ?? internalId;
  const setActiveId = (id: string) => { setInternalId(id); onTabChange?.(id); };
  const active = tabs.find(t => t.id === activeId) ?? tabs[0];

  return (
    <div>
      <ul className="nav nav-tabs">
        {tabs.map(tab => (
          <li key={tab.id} className={[tab.id === active?.id ? 'active' : '', tab.disabled ? 'disabled' : ''].filter(Boolean).join(' ')}>
            <a
              role="tab"
              onClick={e => { e.preventDefault(); if (!tab.disabled) setActiveId(tab.id); }}
              aria-disabled={tab.disabled}
            >
              {tab.heading ?? tab.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content">
        {active?.content}
      </div>
    </div>
  );
}
